import React from 'react';
import useSEO from '../hooks/useSEO';
import { LegalDocument, LegalSection } from '../components/LegalDocument';

function TermsOfService() {
  useSEO({
    title: 'Terms of Service | Nightfall',
    description: 'Terms and conditions for using the Nightfall marketplace.',
    url: 'https://nightfallshop.com/terms',
  });

  return (
    <LegalDocument
      title="Terms of Service"
      subtitle="Rules for using Nightfall as a player or creator."
      lastUpdated="June 4, 2026"
    >
      <LegalSection title="Agreement">
        <p>
          By accessing or using Nightfall, you agree to these Terms of Service.
          If you do not agree, do not use the service.
        </p>
      </LegalSection>

      <LegalSection title="Eligibility">
        <p>
          You must be at least 18 years old to use Nightfall.
          By using the site you confirm that you meet this requirement and that access to adult content is legal where you live.
        </p>
      </LegalSection>

      <LegalSection title="Accounts">
        <p>
          You are responsible for keeping your login credentials secure and for activity under your account.
        </p>
        <p>
          You agree to provide accurate registration information and to update it when it changes.
        </p>
        <p>
          We may suspend or terminate accounts that violate these terms or pose a risk to the platform or other users.
        </p>
      </LegalSection>

      <LegalSection title="Purchases and licenses">
        <p>
          When you buy a game on Nightfall, you receive a license to download and use that game according to the creator's terms, not ownership of the underlying intellectual property.
        </p>
        <p>
          Prices, availability, and featured content may change at any time.
        </p>
        <p>
          Refund eligibility depends on the nature of the purchase and applicable law.
          Contact support if you believe a transaction was made in error.
        </p>
      </LegalSection>

      <LegalSection title="Creator content">
        <p>
          Creators are responsible for the games they publish, including rights to distribute content, age ratings, and compliance with applicable laws.
        </p>
        <p>
          Nightfall may review, reject, or remove content that violates these terms or creates legal or operational risk.
        </p>
      </LegalSection>

      <LegalSection title="Acceptable use">
        <p>You agree not to:</p>
        <p>
          Attempt to bypass purchase or download protections, redistribute purchased files without permission, or scrape the site in ways that harm the service.
        </p>
        <p>
          Upload malware, engage in fraud, harass others, or use Nightfall for unlawful activity.
        </p>
        <p>
          Misrepresent your identity or interfere with the normal operation of the platform.
        </p>
      </LegalSection>

      <LegalSection title="Intellectual property">
        <p>
          Nightfall branding, site design, and platform software are owned by Nightfall or its licensors.
          Game assets remain the property of their respective creators unless otherwise stated.
        </p>
      </LegalSection>

      <LegalSection title="Disclaimers">
        <p>
          Nightfall is provided "as is" without warranties of any kind to the fullest extent permitted by law.
          We do not guarantee uninterrupted access or that every listing will meet your expectations.
        </p>
      </LegalSection>

      <LegalSection title="Limitation of liability">
        <p>
          To the fullest extent permitted by law, Nightfall and its operators are not liable for indirect, incidental, or consequential damages arising from your use of the service.
          Our total liability for any claim related to the service is limited to the amount you paid to Nightfall in the twelve months before the claim, where applicable.
        </p>
      </LegalSection>

      <LegalSection title="Changes">
        <p>
          We may modify these terms at any time.
          Continued use after changes are posted constitutes acceptance of the updated terms.
        </p>
      </LegalSection>

      <LegalSection title="Contact">
        <p>
          For questions about these Terms of Service, reach out through the support options listed on Nightfall.
        </p>
      </LegalSection>
    </LegalDocument>
  );
}

export default TermsOfService;
